import { apiClient } from "..";
import type { WaybillListRequest, WaybillListResponse, WaybillInsertRequest, WaybillInsertResponse, WaybillDeleteRequest, WaybillDeleteResponse } from "../types/waybill";

export class WaybillService {
  static async list(payload: WaybillListRequest): Promise<WaybillListResponse> {
    return apiClient.post<WaybillListResponse>("/scan/waybill/list", payload);
  }

  static async insert(payload: WaybillInsertRequest): Promise<WaybillInsertResponse> {
    return apiClient.post<WaybillInsertResponse>("/scan/waybill/insert", payload);
  }

  static async delete(payload: WaybillDeleteRequest): Promise<WaybillDeleteResponse> {
    return apiClient.post<WaybillDeleteResponse>("/scan/waybill/delete", payload);
  }
}



